<template>
  <v-dialog
    v-model="dialog"
    width="50vw"
    scrollable
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly"
  >
    <v-card>
      <v-card-title class="text-start headline">
        <v-row>
          <v-col>
            <v-icon color="primary"> mdi-clipboard-text-clock </v-icon>
            Historial peticiones
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table
            fixed-header
            height="450px"
            :headers="headers"
            :items="requestHistory"
            :items-per-page="20"
            no-data-text="No hay peticiones"
            loading-text="Cargando peticiones..."
            :page.sync="page"
            hide-default-footer
            :loading="fetchingData"
            @click:row="rowSelect"
          >
            <template #[`item.name`]="{ item }">
              <span class="text-caption warning--text" v-if="item.isHurried"
                >{{ item.name }} - {{ item.sequenceId }}</span
              >
              <span class="text-caption blue--text" v-else-if="item.isModified"
                >{{ item.name }} - {{ item.sequenceId }}</span
              >
              <span
                class="text-caption red--text"
                v-else-if="item.cancellationDate"
                >{{ item.name }} - {{ item.sequenceId }}</span
              >
              <span
                class="text-caption primary--text"
                v-else-if="item.confirmDate"
                >{{ item.name }} - {{ item.sequenceId }}</span
              >
              <span class="text-caption" v-else
                >{{ item.name }} - {{ item.sequenceId }}</span
              >
            </template>
            <template #[`item.quantity`]="{ item }">
              <span class="text-caption"
                >{{ item.quantity }} -
                {{ getContainertype(item.containerType) }}</span
              >
            </template>

            <template #[`item.user`]="{ item }">
              <span class="text-caption"
                >{{ item.user.name }} {{ item.user.lastName }}</span
              >
            </template>
            <template #[`item.createdAt`]="{ item }">
              <span class="text-caption"
                >Entrega: {{ dateFormatShort(item.deliverDate) }}</span
              >
              <v-spacer></v-spacer>
              <span class="text-caption" v-if="item.cancellationDate"
                >Cancelación: {{ dateFormatShort(item.cancellationDate) }}</span
              >

              <span class="text-caption" v-if="item.confirmDate"
                >Confirmación cepario:
                {{ dateFormatShort(item.confirmDate) }}</span
              >
            </template>
            <template #[`item.actions`]="{ item }">
              <v-row v-if="!item.cancellationDate && !item.confirmDate">
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="red"
                        @click="deleteRequest(item)"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar petición</span>
                  </v-tooltip>
                </v-col>
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="green"
                        @click="confirmRequest(item)"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon small>mdi-check-circle-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>Confirmación cepario</span>
                  </v-tooltip>
                </v-col>
                <v-col>
                  <v-menu top :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small color="blue" dark v-bind="attrs" v-on="on">
                        <v-icon small>mdi-circle-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-container>
                          <v-form ref="form_update" lazy-validation>
                            <v-row no-gutters>
                              <v-col cols="12">
                                <v-text-field
                                  dense
                                  outlined
                                  label="Fecha entrega cepario"
                                  type="date"
                                  v-model="resultDate"
                                  :rules="validation()"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-btn
                                  small
                                  color="primary"
                                  @click="updateRequest(item)"
                                  >Actualizar</v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </template>
          </v-data-table>

          <v-pagination
            v-model="page"
            :length="numPages"
            total-visible="20"
            color="primary"
          ></v-pagination>
        </v-container>
      </v-card-text>
      <!-- Actions -->
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn @click="dialog = false" depressed dark block color="gray">
                Cerrar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
// library
import dayjs from "dayjs";
//validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  props: {
    value: Boolean,
    strain: Object,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      headers: [
        {
          text: "Microorganismo",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "Cantidad",
          align: "start",
          value: "quantity",
          sortable: false,
        },
        {
          text: "Usuario",
          align: "start",
          value: "user",
          sortable: false,
        },
        {
          text: "Fechas",
          align: "start",
          value: "createdAt",
          sortable: false,
        },
        {
          text: "Acciones",
          align: "start",
          value: "actions",
          sortable: false,
        },
      ],
      requestHistory: [],
      page: 1,
      numPages: 1,
      fetchingData: false,
      resultDate: null,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    validation(name) {
      return requiredValidation(name);
    },
    ...mapActions("bioactives", [
      "getStrainRequestHistory",
      "cancelStrainRequest",
      "confirmStrainRequest",
      "updateStrainRequest",
    ]),
    rowSelect(rowValue) {},
    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    getContainertype(type) {
      let types = {
        FLASK: "Matraz",
        TUBE: "Tubo",
      };
      return types[type] || "N.E";
    },
    async deleteRequest(item) {
      try {
        let payload = {
          requestId: item._id,
        };
        let response = await this.cancelStrainRequest(payload);
        if (!response) throw response;
        this.$swal({
          icon: "success",
          title: `Petición cancelada!!`,
          showConfirmButton: false,
          timer: 2000,
        });
        await this.fetchData();
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar cancelar petición`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async confirmRequest(item) {
      try {
        let payload = {
          requestId: item._id,
        };
        let response = await this.confirmStrainRequest(payload);
        if (!response) throw response;
        this.$swal({
          icon: "success",
          title: `Petición confirmada!!`,
          showConfirmButton: false,
          timer: 2000,
        });
        await this.fetchData();
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar confirmar petición`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async updateRequest(item) {
      if (this.$refs.form_update.validate()) {
        try {
          let payload = {
            requestId: item._id,
            newDeliveryDate: this.resultDate,
          };
          let response = await this.updateStrainRequest(payload);
          if (!response) throw response;
          this.$swal({
            icon: "success",
            title: `Petición actualizada!!`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.$refs.form_update.resetValidation();
          this.resultDate = null;
          await this.fetchData();
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar actaulización en petición`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getStrainRequestHistory({
          page: this.page,
        });
        if (response) {
          if (!response.error) {
            this.requestHistory = response.history;
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar historial`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar historial`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar historial`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
  },
  watch: {
    async page(value) {
      await this.fetchData();
    },
  },
};
</script>
